import React from 'react';
import { useDispatch } from 'react-redux';
import { logNetRequest } from '@utils/usefulFuncs';
import { sendApiRequest } from '@services/api';
import { Body5, Container } from '@ui';
import { IconButton } from '@ui/buttons/IconButton';
import { Star } from '@assets/icons/svgs/Star';
import { CloseButton } from '@ui/buttons/CloseButton';
import { gridTableAnalysisActions } from '@constants/actionTypes';
import { Edit } from '@assets/icons/svgs/Edit';
import { AddPromptModal } from './AddPromptRow';
import styled from 'styled-components';
import { DiffModeFlag } from './DiffModeFlag';

function _createNullArray(length) {
  return Array.from({ length }, () => null);
}

const Cell = styled.td`
  position: relative;
`;

export const PromptRow = ({ index, prompt, numberOfColumns, docMode }) => {
  const dispatch = useDispatch();

  const [isEditting, setIsEditting] = React.useState(false);
  const [fillCells, setFillCells] = React.useState([]);

  const favId = prompt.id;
  const isFavorite = favId > 0;
  const isMyPrompt = !isFavorite || prompt.is_my_prompt;

  React.useEffect(() => {
    if (numberOfColumns !== fillCells.length) {
      const array = _createNullArray(numberOfColumns);
      setFillCells(array);
    }
  }, [numberOfColumns, fillCells]);

  const handleEditClick = () => {
    setIsEditting(true);
  };

  const onRemoveClick = () => {
    dispatch({
      type: gridTableAnalysisActions.removePrompt,
      payload: prompt,
    });
  };

  const onCreateFavoriteQuestion = async () => {
    const form = {
      ...prompt,
      display_label: prompt.prompt,
      user_mode: docMode,
      user_modes: [docMode],
    };
    const URL = `v1/genai_favorite_prompts`;
    const { status, data, error } = await sendApiRequest('post', URL, form);
    if (status === 200) {
      dispatch({
        type: gridTableAnalysisActions.addFavoriteQuestion,
        payload: data,
      });
    }
  };

  const onUnFav = async () => {
    const URL = `v1/genai_favorite_prompts/${favId}`;
    const { status, data, error } = await sendApiRequest('delete', URL);
    logNetRequest(status, data);
    if (status === 200) {
      dispatch({
        type: gridTableAnalysisActions.removeFavoriteQuestion,
        payload: favId,
      });
    }
  };

  const defaultValues = {
    text: prompt.prompt,
    is_diff_mode: prompt.is_diff_mode,
  };

  return (
    <tr>
      {isEditting && (
        <AddPromptModal
          onDismiss={() => setIsEditting(false)}
          isEditMode
          defaultValues={defaultValues}
          favId={prompt.id || null}
        />
      )}
      <Cell>
        {prompt.is_diff_mode && <DiffModeFlag />}
        <Container row centerAll spaceBetween>
          <Container>
            <Body5>{prompt.block_editting ? prompt.display_label : prompt.display_label || prompt.prompt}</Body5>
          </Container>
          <Container row verticallyCenter left={8}>
            {prompt.block_editting ? null : (
              <Container left={8} top={1}>
                <IconButton onClick={handleEditClick}>
                  <Edit size={17} />
                </IconButton>
              </Container>
            )}

            {prompt.is_default || !isMyPrompt ? null : (
              <Container left={8}>
                <IconButton onClick={isFavorite ? onUnFav : onCreateFavoriteQuestion}>
                  <Star size={18} filled={isFavorite} />
                </IconButton>
              </Container>
            )}

            <Container left={8}>
              <CloseButton onClick={onRemoveClick} size={12} />
            </Container>
          </Container>
        </Container>
      </Cell>
      {fillCells.map((c, i) => (
        <td key={i} />
      ))}
    </tr>
  );
};
